import { render, staticRenderFns } from "./TheoryExamine.vue?vue&type=template&id=cd4cac70&scoped=true"
import script from "./TheoryExamine.vue?vue&type=script&lang=js"
export * from "./TheoryExamine.vue?vue&type=script&lang=js"
import style0 from "./TheoryExamine.vue?vue&type=style&index=0&id=cd4cac70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4cac70",
  null
  
)

export default component.exports